import { Controller } from "@hotwired/stimulus"

// Shows the shared confirmation modal carrying a one-off flash message.
// The controller element is only rendered when the server set a flash, so
// connecting is the right trigger — no global turbo:load/turbo:render listener.
export default class extends Controller {
  connect() {
    const raw = this.element.getAttribute("data-flash")
    if (!raw) return

    const messages = JSON.parse(raw)
    if (!messages || messages.length === 0) return

    document.getElementById("modal-body1").innerHTML = messages[0].message
    document.getElementById("modal-title").innerHTML = ""
    document.getElementById("modal-body2").innerHTML = ""
    document.getElementById("modal-buttons").classList.add("d-none")

    document.getElementById("dataConfirm").classList.add("is-open")
    this.element.removeAttribute("data-flash")
  }
}
